export default __webpack_public_path__ + "static/media/ic_Pick-Up.adbffa88.svg";